import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=de0845f0"
var script = {}
import style0 from "./barcode.vue?vue&type=style&index=0&id=de0845f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports